<template>
  <v-card flat>
    <v-card-title>Avvikelse</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            :items="items"
            item-value="data"
            item-text="_text"
            :value-comparator="valueComparator"
            outlined
            label="Avvikelser"
            item-disabled="hidden"
            v-model="model.deviations"
            multiple
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click:close="remove(data.item)"
              >
                {{ data.item._text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <template v-if="searchParameters">
        <template v-for="(deviation, $i) in model.deviations">
          <v-container :key="$i">
            <v-row>
              <v-col>
                {{ getDescription(deviation.code) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col v-for="param in deviation.parameters" :key="param.name">
                <template v-if="getParam(param.name).autocompleteList.length">
                  <v-autocomplete
                    :items="getParam(param.name).autocompleteList"
                    v-model="param.value"
                    :placeholder="'Välj ' + param.name"
                    :hint="getParam(param.name).description"
                    :rules="[
                      required,
                      v =>
                        !!new RegExp(getParam(param.name).regex).test(v) ||
                        'Ogiltig'
                    ]"
                    outlined
                    :label="param.name"
                  />
                </template>
                <v-text-field
                  v-else
                  :label="param.name"
                  outlined
                  v-model="param.value"
                  :hint="getParam(param.name).description"
                  :rules="[
                    required,
                    v =>
                      !!new RegExp(getParam(param.name).regex).test(v) ||
                      'Ogiltig'
                  ]"
                />
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-container>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from '@/common/validationRules'
import SEARCH_PARAMETERS from '../../graphql/searchParameters'
import { get } from 'vuex-pathify'

export default {
  name: 'DuwaDeviations',

  props: {
    codes: {
      type: Array,
      default: () => []
    }
  },

  apollo: {
    searchParameters: {
      query: SEARCH_PARAMETERS,
      fetchPolicy: 'no-cache'
    }
  },

  data: () => ({
    required,
    model: {
      deviations: []
    }
  }),

  created() {
    this.model.deviations = this.currentDeviations.slice()
  },

  watch: {
    'model.deviations'(value) {
      this.$store.set(
        'duwa/payload',
        this.payload.map(x => ({
          ...x,
          deviation: {
            ...x.deviation,
            after: value
          }
        }))
      )
    }
  },

  computed: {
    payload: get('duwa/payload'),
    currentDeviations: get('duwa/currentDeviations'),

    items() {
      return this.codes
        .filter(x => x.category === 'deviation')
        .map(x => {
          if (x.text_43_characters) {
            x._text = x.text_43_characters
          } else if (x.text_13_characters) {
            x._text = x.text_13_characters
          } else if (x.text_9_characters) {
            x._text = x.text_9_characters
          }
          x.data = {
            parameters: (x.parameters || []).map(({ name, value }) => ({
              name,
              value
            })),
            code: x.code
          }
          return x
        })
        .filter(
          x =>
            !x.hidden ||
            this.currentDeviations.some(({ code }) => code === x.code)
        )
    }
  },

  methods: {
    getParam(attribute) {
      return (this.searchParameters || []).find(
        x => x.attribute === attribute.toLowerCase()
      )
    },

    valueComparator(a, b) {
      if (!a || !b) return false
      const transformB = Array.isArray(b) ? b : [b]
      return transformB.some(x => x.code === a.code)
    },
    getDescription(code) {
      return this.items.find(x => x.code === code)._text
    },

    isDisabled(code) {
      return this.items.find(x => x.code === code).hidden
    },

    remove(item) {
      const index = this.model.deviations.findIndex(x => x.code === item.code)
      if (index >= 0) this.model.deviations.splice(index, 1)
    }
  }
}
</script>
